export const SYNC_RETRY_STATES = ["ready", "failed"];

export const SYNC_OUTCOME = {
  marked_live: { label: "Marked live", tone: "text-emerald-700" },
  not_synced: { label: "Not marked live", tone: "text-amber-700" },
  failed: { label: "Could not save", tone: "text-rose-700" },
};

/** launch_date stops being editable at this hour (IST) on the launch day. */
export const LAUNCH_DATE_LOCK_HOUR = 23;

/** Status tab for Ready ads whose launch_date is today or earlier. */
export const DUE_TODAY_STATUS = "due_today";

/** What each launch status means, shown on hover over its chip, summary pill or tab. */
export const LAUNCH_STATUS_HINTS = {
  all: "Every hook on this page, whatever its status.",
  ready:
    "All hooks approved and nothing launched yet. Launch it here; with auto launch on, AMS schedules it on Meta within minutes of the last approval.",
  due_today: "Ready, and its launch date is today or earlier.",
  scheduled:
    "Set to launch at a chosen time. AMS creates it on Meta at that time.",
  queued: "Waiting for its turn. AMS creates it on Meta in the next batch.",
  processing:
    "AMS is creating it on Meta right now: video, creative, ad set and ad.",
  meta_scheduled:
    "Created on Meta and waiting for its start time, usually 12 AM. Also shown while Meta is still reviewing it.",
  success:
    "Launched on Meta. The chip beside it shows whether Meta is running it.",
  failed:
    "It did not go live. Meta rejected it, or the launch errored. The reason is under the status.",
  schedule_failed:
    "Auto launch could not create it on Meta. The reason is under the status. Retry it, or it is tried again at 11:15 PM.",
  cancelled:
    "The launch was cancelled before it ran, or auto launch was turned off.",
  in_review: "Not launchable yet: still in QC or moderation.",
  qc_pending: "Delivered, waiting for Ad Delivery QC.",
  qc_changes_requested: "QC asked the agency for changes.",
  moderation_pending: "Waiting for a moderator's decision.",
  moderation_approved:
    "Approved by a moderator. Waiting on the other hooks of this ad set.",
  moderation_rejected: "Rejected in moderation.",
  final_rejected: "Rejected in moderation.",
  auto_launch: "Launched by auto launch, not by hand.",
};
